import { autoinject, customAttribute } from 'aurelia-framework';
import { ComponentContext } from './ComponentContext';

@autoinject
@customAttribute('component-context')
export class ComponentContextCustomAttribute {
  private static contextKey = '__component_context__';
  private static dataAttribute = 'data-provides-context';

  constructor(private element: Element) {}

  valueChanged(newValue: ComponentContext<any>) {
    this.element[ComponentContextCustomAttribute.contextKey] = newValue;
    // Mark element with data attribute for easier discovery
    this.element.setAttribute(ComponentContextCustomAttribute.dataAttribute, 'true');
  }

  static findContext<T extends object>(element: Element): ComponentContext<T> | null {
    let current = element;
    while (current) {
      // Use querySelector to find the nearest parent with context
      const contextProvider = this.findNearestContextProvider(current);
      if (contextProvider && contextProvider[this.contextKey]) {
        return contextProvider[this.contextKey];
      }

      // Move up to parent and try again (handles nested compositions)
      current = current.parentElement;
      if (!current) break;
    }

    return null;
  }

  private static findNearestContextProvider(startElement: Element): Element | null {
    // Get all elements with context in the document
    const contextProviders = Array.from(document.querySelectorAll(`[${this.dataAttribute}="true"]`));

    console.log('Context providers in document:', contextProviders);

    if (contextProviders.length === 0) return null;

    // Find the closest ancestor that provides context
    let current = startElement.parentElement;
    while (current) {
      if (contextProviders.includes(current)) {
        return current;
      }
      current = current.parentElement;
    }

    // If no ancestor found, check if any provider contains this element
    for (const provider of contextProviders) {
      if (provider.contains(startElement)) {
        return provider;
      }
    }

    return null;
  }
}
